module.exports = __webpack_public_path__ + "static/WEDDING E&M-237-0bc2a60e12c128b790b5777b7b6087bc.jpg";